import React from 'react'
import { useInView } from 'react-intersection-observer'

import Breadcrumb from '../breadcrumb'
import Wysiwyg from '../wysiwyg'
import Image from '../image'

import roundShape from '../../icons/round-shape.svg'
import semiroundShape from '../../icons/semiround-shape.svg'
import slugify from 'slugify'

const SolutionHero = ({data, currentUrl}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const chapo = (data.chapo) ? data.chapo : null
  const breadcrumbLabel = (data.breadcrumbCurrentLabel) ? data.breadcrumbCurrentLabel : data.title
  const type = slugify(data.solution).toLowerCase()

  let semiroundColor = null

  switch(type) {
    case 'hydrogene':
      semiroundColor = 'parma'
      break
    case 'digital':
      semiroundColor = 'sienne'
      break
    case 'mobilite-bas-carbone':
      semiroundColor = 'aqua'
      break
    case 'methanisation':
      semiroundColor = 'beige'
      break
    case 'co2':
      semiroundColor = 'tumbleweed'
      break
    default:
      return 'error'
  }

  return (
    <div className={`hero solution-hero relative ${inView ? 'has-anim' : ''}`} ref={ref}>
      <Breadcrumb 
        currentUrl={currentUrl}
        links={data.breadcrumb ? data.breadcrumb : null} 
        current={breadcrumbLabel} 
        type="solution"
        isAbsolute={true}
      />
      <div className="row mb-10 md:mb-20 items-start">
        <div className={`col-12 md-col-5 order-last md:order-first solution-hero__content gradient-${type} has-full-bg`}>
          <div className="relative">
            <svg className={`absolute icon-${semiroundColor} solution-hero__semiround`} width="90" height="92">
              <use xlinkHref={semiroundShape.url} />
            </svg>

            <h1 className="title title-page title-page--big hero__title scroll-anim-el">{data.title}</h1>

            { chapo &&
              <div className="row mt-6 md:mt-8">
                <div className="col-12 xl-col-4">
                  <Wysiwyg classes="paragraph-big scroll-anim-el scroll-anim-el--2" document={chapo} />
                </div>
              </div>
            }
          </div>
        </div>
        <div className="col-12 md-col-offset-1 md-col-6 relative">
          <div className="solution-hero__shape shaped-image shaped-image--hero">
            { data.mainImage &&
            <Image
              width="1200"
              height="1090"
              isTop={true}
              classes="object-fit-image solution-hero__img"
              sizes={{"415": [400, 400], "767": [600, 700], "1023": [550, 785], "1600": [825, 1090] }}
              image={data.mainImage} />
            }
          </div>
          
          { data.secondaryImage &&
            <Image
              width="322"
              height="322"
              isTop={true}
              classes="solution-hero__quad shaped-image shaped-image--quad-rotate scroll-anim-el scroll-anim-el--3"
              sizes={{"415": [128, 128], "768": [170, 170], "1024": [232, 232] }}
              image={data.secondaryImage} />
          }

          <svg className="absolute icon-gradient-blue solution-hero__round" width="65px" height="65px">
            <use xlinkHref={roundShape.url} />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default SolutionHero
